<template>
    <DefaultHeader />
    <CreateModal @chose="createCorridoring" />
    <div :class="{ 'd-none': this.$store.state.hiddenBody }" class="container-fluid">
        <div class="row d-flex justify-content-center">
            <div class="col-3 mb-lg-2 d-flex justify-content-center">
                <SearchDisplay :searchFunction="'searchWord'" @searchWord="refreshData" ref="inputDisplay" />
            </div>
        </div>
        <div class="row d-flex justify-content-center">
            <div class="col-11 mb-3 mb-lg-5">
                <div class="card table-nowrap table-card">
                    <div class="table-responsive">
                        <table class="table mb-0 table-striped">
                            <thead class="small bg-body text-muted">
                                <tr>
                                    <th v-if="!this.isViewer" colspan="3" class="text-end">
                                        <ButtonDisplay :type="'add'" :text="'Ajouter'" data-bs-toggle="modal"
                                            data-bs-target="#exampleModal" />
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                <TableRow v-for="corridoring in corridorings" :key="corridoring.id"
                                    :corridoring="corridoring" @save="updateCorridoring" @delete="deleteCorridoring" />
                            </tbody>
                        </table>
                        <div v-if="corridorings && corridorings.length === 0" class="p-4 text-center text-muted">
                            Aucun corridoring pour le moment.
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <DefaultFooter />
</template>

<script>
import DefaultHeader from '@/components/DefaultHeader.vue'
import DefaultFooter from '@/components/DefaultFooter.vue'
import CorridoringService from '@/services/corridoring.service.js'
import FormatHelper from '@/helpers/format.helper.js'
import ButtonDisplay from '@/components/display/ButtonDisplay.vue'
import SearchDisplay from '@/components/display/SearchDisplay.vue'
import TableRow from './Sections/TableRow.vue'
import CreateModal from './Sections/CreateModal.vue'
import UserHelper from '@/helpers/user.helper.js'


export default {
    components: {
        DefaultHeader,
        DefaultFooter,
        TableRow,
        ButtonDisplay,
        SearchDisplay,
        CreateModal
    },
    data() {
        return {
            corridorings: []
        };
    },
    mounted() {
        this.refreshData();
    },
    computed: {
        isViewer() {
            return UserHelper.isViewer(this.$store.state.auth.user);
        },
    },
    methods: {
        refreshData() {
            CorridoringService.getClientCorridorings(this.$refs.inputDisplay.searchInput)
                .then(response => {
                    this.corridorings = FormatHelper.corridoringsFormat(response.data);
                })
                .catch(e => {
                    console.log(e);
                });
        },
        updateCorridoring(cId, name) {
            CorridoringService.updateCorridoring(cId, { name: name })
                .then(() => {
                    this.refreshData();
                })
                .catch(e => {
                    console.log(e);
                });
        },
        deleteCorridoring(cId) {
            CorridoringService.deleteCorridoring(cId)
                .then(() => {
                    this.refreshData();
                })
                .catch(e => {
                    console.log(e);
                });
        },
        // payload peut venir d'un trajet OU d'une plage de dates
        createCorridoring(payload) {
            const isRange = payload && payload.mode === 'range';

            const call = isRange
                ? CorridoringService.createCorridoringFromRange({
                    baliseId: payload.baliseId,
                    from: payload.from,
                    to: payload.to,
                    name: payload.name,
                })
                : CorridoringService.createCorridoring(payload.driveId, payload.name);

            call
                .then(() => this.refreshData())
                .catch(e => console.log(e));
        },
    }
}
</script>